const getDefaultBespokeSelection = () => ({
  optIn: false,
  summary: "",
});

export const state = () => ({
  variantLoading: false,
  processing: false,
  bottomline: null,
  reviews: [],
  mattressProtector: null,
  mattressAndBaseRemoval: null,
  customizations: [],
  bespokeSelection: getDefaultBespokeSelection(),
  isMembersInfoVisible: false,
});

export const actions = {
  async getReviewRating({ commit, rootState }, { productId }) {
    const reviewsPerPage = rootState.siteConfig.reviewsPerPage;
    const url = this.$config.yotpoReviewUrl.replace("$productId", productId);

    try {
      await this.$axios
        .get(`${url}?page=1&per_page=${reviewsPerPage}`)
        .then(({ data }) => {
          commit("setReviewRating", { ...data.response });
        });
    } catch (err) {
      this.$bugsnag.notify(err);
    }
  },
  setVariantLoading({ commit }) {
    commit("SET_VARIANT_LOADING", true);
  },
  resetVariantLoading({ commit }) {
    commit("SET_VARIANT_LOADING", false);
  },
  setMattressProtector({ commit }, payload) {
    commit("SET_MATTRESS_PROTECTOR", payload);
  },
  updateCustomization({ commit }, variantIds) {
    commit("UPDATE_CUSTOMIZATION", variantIds);
  },
  setBespokeSelection({ commit }, payload) {
    commit("SET_BESPOKE_SELECTION", payload);
  },
  resetBespokeSelection({ commit }) {
    commit("RESET_BESPOKE_SELECTION");
  },
  setMembersInfoVisibility({ commit }, isVisible) {
    commit("SET_MEMBERS_INFO_VISIBILITY", isVisible);
  },
  setMattressAndBaseRemoval({ commit }, payload) {
    commit("SET_MATTRESS_AND_BASE_REMOVAL", payload);
  },
};

export const mutations = {
  setReviewRating(state, { bottomline, reviews }) {
    state.bottomline = bottomline;
    state.reviews = reviews;
  },
  SET_VARIANT_LOADING(state, status) {
    state.variantLoading = status;
  },
  SET_MATTRESS_PROTECTOR(state, payload) {
    state.mattressProtector = payload;
  },
  UPDATE_CUSTOMIZATION(state, variantIds) {
    state.customizations = variantIds;
  },
  SET_BESPOKE_SELECTION(state, payload) {
    state.bespokeSelection = {
      ...state.bespokeSelection,
      ...payload,
    };
  },
  RESET_BESPOKE_SELECTION(state) {
    state.bespokeSelection = getDefaultBespokeSelection();
  },
  SET_MEMBERS_INFO_VISIBILITY(state, isVisible) {
    state.isMembersInfoVisible = isVisible;
  },
  SET_MATTRESS_AND_BASE_REMOVAL(state, payload) {
    state.mattressAndBaseRemoval = payload;
  },
};
